module.exports = __webpack_public_path__ + "img/ids_logo85px.60280d80.png";